import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { queryClient } from "@/lib/react-query";

import { useRemoveMeFromEvent } from "../api/remove-me-from-event";

type NoLongerCanAttendModalProps = {
  eventId: string;
};

function NoLongerCanAttendModal({ eventId }: NoLongerCanAttendModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { organisation } = useOrganisation();
  const { mutateAsync: removeMeFromEvent, isPending } = useRemoveMeFromEvent(
    organisation.id,
    eventId,
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.includes("event"),
        });
      },
    },
  );

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="link">No longer attending?</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>No longer attending?</DialogTitle>
          <DialogDescription>
            If you no longer want to attend this event, you can remove yourself
            from the participant list.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex gap-3">
            <Button
              type="submit"
              isLoading={isPending}
              isAnimated={isPending}
              disabled={isPending}
              variant="destructive"
              size="xs"
              onClick={() => removeMeFromEvent()}
            >
              Confirm
            </Button>
            <Button variant="outline" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default NoLongerCanAttendModal;
